import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('listheader');

export { TAG_NAME };
